/*
 * File: status-area.ts
 * File Created: 2024-10-21 10:58:30
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-10-21 10:58:45
 * Modified By: Val Liu
 * -----
 */

import { NumberHelper } from "@root/core";
import { Vue, Component } from "vue-property-decorator";

@Component
export default class StatusArea extends Vue {
    toFixed(num: number, digits: number) {
        return NumberHelper.toFixedNumber(num, digits);
    }
    toFixedSpeed(num: number, digits: number) {
        return this.toFixed(num / 1024, digits);
    }
}
